import medialib from '../api/medialib/sagas';
import spellCheck from '../containers/SpellCheck/sagas';

export default [
  medialib,
  spellCheck,
];
